import { AggregateFunctions, AggregateQuery } from "../types";
import { AssetTimeseriesGroupBy } from "~/modules/asset_timeseries_v4/types";
import { SelectInput } from "~/components/SelectInput";

// // // //

const groupByOptions = [
    {
        value: AssetTimeseriesGroupBy.asset,
        content: {
            label: "Asset",
        },
    },
    {
        value: AssetTimeseriesGroupBy.assetTicker,
        content: {
            label: "Asset Ticker",
        },
    },
    {
        value: AssetTimeseriesGroupBy.assetClass,
        content: {
            label: "Asset Class",
        },
    },
    {
        value: AssetTimeseriesGroupBy.issuer,
        content: {
            label: "Issuer",
        },
    },
    {
        value: AssetTimeseriesGroupBy.measure,
        content: {
            label: "Measure",
        },
    },
    {
        value: AssetTimeseriesGroupBy.peggedAsset,
        content: {
            label: "Pegged Asset",
        },
    },
    {
        value: AssetTimeseriesGroupBy.jurisdictionCountry,
        content: {
            label: "Jurisdiction Country",
        },
    },
];

const aggregateFunctionOptions = [
    {
        value: AggregateFunctions.Sum,
        content: {
            label: "Sum",
        },
    },
    {
        value: AggregateFunctions.Avg,
        content: {
            label: "Avg",
        },
    },
    {
        value: AggregateFunctions.Min,
        content: {
            label: "Min",
        },
    },
    {
        value: AggregateFunctions.Max,
        content: {
            label: "Max",
        },
    },
    // {
    //     value: AggregateFunctions.Count,
    //     content: {
    //         label: "Count",
    //     },
    // },
];

export function AssetAggregateQueryInput(props: {
    value: AggregateQuery;
    allowedGroupByValues?: Array<AssetTimeseriesGroupBy>;
    onChange: (updatedAggregateQuery: AggregateQuery) => void;
}) {
    const {
        value,
        onChange,
        allowedGroupByValues = [
            AssetTimeseriesGroupBy.asset,
            AssetTimeseriesGroupBy.assetTicker,
            AssetTimeseriesGroupBy.assetClass,
            AssetTimeseriesGroupBy.issuer,
            AssetTimeseriesGroupBy.measure,
            AssetTimeseriesGroupBy.peggedAsset,
            AssetTimeseriesGroupBy.jurisdictionCountry,
        ],
    } = props;

    const handleGroupByChange = (selectedGroupBy: AssetTimeseriesGroupBy) => {
        onChange({
            groupBy: selectedGroupBy,
            aggregateFunction: value.aggregateFunction,
        });
    };

    const handleAggregateFunctionChange = (
        selectedAggregateFunction: AggregateFunctions,
    ) => {
        onChange({
            groupBy: value.groupBy,
            aggregateFunction: selectedAggregateFunction,
        });
    };

    return (
        <div className="mb-4 flex items-center gap-4 w-fit">
            <div className="flex flex-col w-full">
                <p className="text-slate-600">Group By</p>
                <SelectInput
                    value={value.groupBy}
                    onChange={(updatedValue) =>
                        handleGroupByChange(
                            updatedValue as AssetTimeseriesGroupBy,
                        )
                    }
                    options={groupByOptions.filter((each) =>
                        allowedGroupByValues.includes(each.value),
                    )}
                    size="lg"
                />
            </div>
            <div className="flex flex-col w-full">
                <p className="text-slate-600 whitespace-nowrap">
                    Aggregate Function
                </p>
                <SelectInput
                    value={value.aggregateFunction}
                    onChange={(updatedValue) =>
                        handleAggregateFunctionChange(
                            updatedValue as AggregateFunctions,
                        )
                    }
                    options={aggregateFunctionOptions}
                    size="lg"
                />
            </div>
        </div>
    );
}
